export const ACCOUNT_COOKIE_NAME = 'currentAccountId';
export const ACCOUNT_LOCAL_STORAGE_NAME = 'currentAccountId';
export const SSO_HINT_COOKIE_NAME = 'ssohint';
export const SESSION_URL = '/api/v4/session/';
export const SESSION_COOKIE_STATUS_URL = '/api/bridge/session-cookie-status';
export const LOGIN_URL = '/app/login';

export const JWT_REFRESH_INTERVAL = 10 * 60 * 1000; // 10 minutes in milliseconds

// Cap on how often IdentityProvider re-validates a PRESENT currentAccountId
// cookie against /api/v4/session/ (per browser, tracked in localStorage). An
// absent cookie always reconciles immediately.
export const ACCOUNT_RECONCILE_TTL = 15 * 60 * 1000; // 15 minutes in milliseconds
export const ACCOUNT_RECONCILED_AT_STORAGE_NAME =
  'currentAccountIdReconciledAt';

// Delay before the final retry of an inconclusive JWT refresh (see useJWTRefresh).
export const JWT_REFRESH_RETRY_BACKOFF = 2000; // 2 seconds in milliseconds
